import { DateTimeFormatStyle } from "@hopper-i18n/formatter";
import dayjs from "dayjs";

/**
 * Formats a 24h time string (e.g., "14:30") into a locale-appropriate format.
 * - fr-CA → "14:30" (24h)
 * - en-CA → "02:30 PM" (12h)
 */
export const formatLocalizedTime = (
  time24Hour: string,
  language: string
): string => {
  if (!time24Hour) return "";
  const parsed = dayjs(time24Hour, "HH:mm");
  if (!parsed.isValid()) return time24Hour;

  return new Intl.DateTimeFormat(language, {
    hour: "numeric",
    minute: "2-digit",
  }).format(parsed.toDate());
};

/**
 * Formats a date as "MMM DD, YYYY (Weekday)" using i18n formatters
 * @example "May 10, 2026 (Tue)"
 *
 * Returns "" for an invalid Date so callers never render "Invalid Date"
 * (e.g. when a segment date string is empty or malformed). Callers that join
 * these values already drop empty strings.
 */
export const formatDateWithWeekday = (
  date: Date,
  formatDateTime: (date: Date, style: DateTimeFormatStyle) => string
): string => {
  if (isNaN(date.getTime())) {
    return "";
  }
  const dateFormat = DateTimeFormatStyle.MediumDate;
  const weekdayFormat = DateTimeFormatStyle.Custom({ weekday: "short" });
  return `${formatDateTime(date, dateFormat)} (${formatDateTime(date, weekdayFormat)})`;
};
